<template>
  <component :is="as" class="set_slat_ctg" @click="setCategory">
    <figure class="set_slat__wrapper">
      <slot name="image"/>
      <figcaption class="set_slat__caption"><slot/></figcaption>
    </figure>
  </component>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    as: {
      type: String,
      default: 'li'
    },
    ctgMap: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations(['setModal']),
    ...mapActions('simulator', ['setSlatCtgSelected']),
    setCategory () {
      this.setSlatCtgSelected(this.ctgMap)
      this.setModal('BrowseSlatByCtg')
    }
  }
}
</script>

<style lang="scss" scoped>
  .set_slat_ctg {
    position: relative;
    color: white;
    background-color: #ddd;
    border-radius: 6px;
    cursor: pointer;
    &::before {
      display: block;
      content: '';
      padding-top: calc(96 / 122 * 100%);
    }
    &.sohostyle {
      background-color: #686669;
    }
    &.industrial {
      background-color: #1d295b;
    }
    &.botanical {
      background-color: #10522d;
    }
    &.nordic {
      background-color: #c9ba98;
    }
    &.wa- {
      background-color: #6A6F27;
    }
    &.sudare {
      background-color: #8C5F26;
    }
    &.sudare-ish {
      background-color: #8C5F26;
      color: #fff;
    }
    &.muji {
      background-color: #D4C9AD;
    }
    &.shakou {
      background-color: #4E6388;
      color: #fff !important;
    }
    &.lace {
      background-color: #F2F2F3;
      border: 1px solid #9A9A9A;
    }
    &.toki-washi {
      background:
        linear-gradient(
          120deg, #ECE4D7 0%, #ECE4D7 60%, #E8D497 60%, #E8D497 100%
        );
    }
    &.toki-sudare {
      background:
        linear-gradient(
          120deg, #ECE4D7 0%, #ECE4D7 60%, #8B7F71 60%, #8B7F71 100%
        );
    }
    &.washi {
      background-color: #e67e53;
    }
    &.phyto{
        background-color: #9EB2BD;
        color: #000;
    }
    &.calm{
      background-color: #A9A5B0;
      color: #000;
    }
    &.fun{
      background-color: #D2DE7D;
      color: #000;
    }
    &.slow{
      background-color: #BDA182;
      color: #000;
    }
    &.feel_clear{
      background-color: #D1EBF9;
      color: #000;
    }
    &.wood{
      background-color: #86755E;
      color: #000;
    }
    &.phyto_calm{
      background:
        linear-gradient(
          120deg, #9EB2BD 0%, #A8A4AF 100%
        )
    }
    &.fun_slow{
      background:
        linear-gradient(
          120deg, #D2DE7D 0%, #BDA182 100%
        )
    }
    .set_slat__wrapper {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-content: flex-start;
      align-items: flex-start;
      position: absolute;
      margin: 0;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-size: clamp(10px, 1.2vw, 16px);
      .set_slat__image {
        flex: 0 1 auto;
        margin: calc(8 / 122 * 100%);
        margin-bottom: calc(2 / 122 * 100%);
        width: calc(102 / 122 * 100%);
        height: auto;
      }
      .set_slat__caption {
        width: 100%;
        text-align: center;
        > img {
          margin-top: 1%;
          width: calc(68 / 122 * 100%);
          height: auto;
        }
        [class^=toki-] {
          display: block grid;
          grid-template-columns: 40% 1fr;
          &::before {
            content: 'トキ';
            padding-inline-start: 2em;
            justify-self: center;
            color: #333;
          }
        }
        .toki-washi {
          color: #333;
        }
      }
    }
    &.no_ratio {
      color: black;
      &::before {
        padding-top: 0;
      }
      .set_slat__wrapper {
        align-content: normal;
        align-items: center;
        font-size: clamp(10px, 1.4vw, 18px);
      }
    }
  }
</style>